import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faArrowRight, faCheckCircle, faCircle, faCircleCheck, faDashboard, faMagnifyingGlass, faMap, faUser, faUserAlt, faUsers } from "../../../../node_modules/@fortawesome/free-solid-svg-icons/index";

const AdminSideBarNature = () => {
    function toggleClass() {
        document.getElementById("toggleli").childNodes[1].classList.toggle("collapse")
    }
    function masterClass() {
        document.getElementById("Master").childNodes[1].classList.toggle("collapse")
    }

    return (

        <aside id="myDIV" className="sidebar">

            <ul className="sidebar-nav" id="sidebar-nav">
     
                <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/nature/dashboard">
                        <i><FontAwesomeIcon icon={faDashboard} /></i>
                        <span> Dashboard</span>
                    </NavLink>
                </li>

                <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/nature/cropsurvey">
                        <i><FontAwesomeIcon icon={faUsers} /></i>
                        <span>Crop Survey</span>
                    </NavLink>
                </li>

                <li className="nav-item">
                    <NavLink className="nav-link collapsed" to="/home/access">
                        <i><FontAwesomeIcon icon={faDashboard} /></i>
                        <span> All Schemes</span>
                    </NavLink>
                </li>

       
              


            </ul>

        </aside>
    )

}

export default AdminSideBarNature;